<ivy-authentication-template>
    <div page-title>
      <span [innerHTML]="'product.exception.unauthorized_user' | translate">
      </span>
    </div>
    <div id="center-box" class="">
      <button class="btn btn-primary" (click)="logInAgain()" translate="product.loginButton">
      </button>
    </div>
  </ivy-authentication-template>
  